import React, { useEffect, useState } from "react";
interface Data {
  labels?: string[];
  items?: { name?: string; data?: string }[];
}

const CardEnvioDados: React.FC<any> = (props) => {
  const [data, setData] = useState<Data[]>([]);

  useEffect(() => {
    setData([
      {
        labels: ["Cadastro"],
        items: [
          { name: "Raça", data: "Nelore" },
          { name: "Série", data: "ESL RGN 4012 RGD" },
          { name: "Nome", data: "Janeiro ESL" },
          { name: "Data Nascimento", data: "30/12/2020" },
        ],
      },
      {
        labels: ["Peso"],
        items: [
          { name: "Série", data: "ESL RGN 4012 RGD" },
          { name: "Nome", data: "Jurado ESL" },
          { name: "Peso", data: "104 Kg Manejo pasto lote 20" },
          { name: "Data Pesagem", data: "10/02/2021" },
        ],
      },
      {
        labels: ["Perímetro"],
        items: [
          { name: "Série", data: "ESL RGN 3845 RGD" },
          { name: "Nome", data: "Jabuta ESL" },
          { name: "PE", data: "235mm manejo pasto lote 20" },
          { name: "Data medição", data: "10/02/2021" },
        ],
      },
      {
        labels: ["Molecular"],
        items: [{ name: "Versão", data: "Clarifide 30" }],
      },
    ]);
  }, []);

  return (
    <div className="card border border-primary mb-3">
      <div className="card-header bg-primary border border-primary py-4">
        <h6 className="card-title fw-bold text-white m-0 py-1">
          Últimos dados informados
        </h6>
      </div>
      <div className="card-body p-0 pb-3">
        {data &&
          data.map((subData, index) => {
            return (
              <>
                <div key={index} className="bg-light">
                  <div>
                    <div
                      className="bg-white shadow fw-bold"
                      style={{ height: 43 }}
                    >
                      <div className="d-flex flex-row align-items-center ">
                        {subData &&
                          subData.labels &&
                          subData.labels.map((label, i) => {
                            return (
                              <div className="row g-0 px-3 " key={i}>
                                <div className="col h-100 d-flex align-items-center h-100">
                                  <small>{label}</small>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>

                    {subData &&
                      subData.items &&
                      subData.items.map((item, itemIndex) => {
                        return (
                          <div
                            className={
                              "row g-0 px-3 " +
                              (itemIndex % 2 == 0 ? "" : "bg-white")
                            }
                            key={itemIndex}
                            style={{ height: 57 }}
                          >
                            <div className="col h-100 d-flex align-items-center ">
                              <small>{item.name}</small>
                            </div>
                            <div className="col h-100 d-flex align-items-center border-start border-2 border-white">
                              <small className="m-2">{item.data}</small>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </>
            );
          })}
      </div>
    </div>
  );
};

export default CardEnvioDados;
